const toolbars = require.context('.', false, /\.json$/);

export default toolbars.keys().reduce((templates, key) => {
  const template = key.replace(/.\/+/g, '').replace('.json', '');
  const config = toolbars(key);
  const yAxisConfig = toolbars('./yAxis.json');
  const isCategorical =
    key.toLowerCase().includes('categorical') || key.toLowerCase().includes('vertical');

  if (!key.includes('yAxis')) {
    templates[template] = { ...config, ...(isCategorical && { yAxis: yAxisConfig }) };
  }
  return templates;
}, {});
